import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartBar } from './useGetChartBar'
import { ChartBarContent } from './ChartBarContent'
import { ChartLoading } from '../ChartComponent'
import { ChartBarEmptyResponse } from './ChartBarEmptyResponse'
import { isRenderableChartBarResponse } from './chartBarUtils'

export const ChartBarComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data, refetch } = useGetChartBar(id, tileFilterSelections)

  if (!isRenderableChartBarResponse(data)) {
    return (
      <ChartBarEmptyResponse
        title={data.uiSchema?.title}
        description={data.uiSchema?.description}
        emphasizeHeader={data.uiSchema?.emphasizeHeader}
        tileFilters={<TileFilter schema={data.filters} />}
        reloadHandler={refetch}
      />
    )
  }

  return (
    <ChartBarContent
      reloadHandler={refetch}
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartBarComponentLoading() {
  return <ChartLoading />
}
